import { StyleSheet } from 'aphrodite';
import {
	white,
	borderOutline,
	titles,
	lightGray,
	shuffleGray,
	darkGrayFontColor,
	charmGray,
	brandPrimary,
	brandPrimaryActive,
	brandPrimaryHoverTint,
	brandSecondaryText,
	destructive,
	backgroundAlt,
	successTint,
	antiFlashWhite,
	background,
	aceGray,
	warningLight,
	warningDark,
	error,
	errorLight,
	green3,
} from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		paddingTop: 16,
		paddingBottom: 16,
		paddingLeft: 24,
		paddingRight: 24,
		backgroundColor: white,
		borderBottom: `1px solid ${borderOutline}`,
	},
	headerTitle: {
		fontSize: 18,
		fontWeight: 600,
		color: titles,
	},
	toggleContainer: {
		display: 'flex',
		gap: 4,
		backgroundColor: lightGray,
		borderRadius: 6,
		padding: 4,
	},
	toggleButton: {
		paddingTop: 6,
		paddingBottom: 6,
		paddingLeft: 16,
		paddingRight: 16,
		fontSize: 13,
		fontWeight: 500,
		backgroundColor: 'transparent',
		border: 'none',
		borderRadius: 4,
		cursor: 'pointer',
		color: darkGrayFontColor,
		transition: 'all 0.2s',
		':hover': {
			backgroundColor: shuffleGray,
		},
		':disabled': {
			cursor: 'not-allowed',
			opacity: 0.4,
			backgroundColor: 'transparent',
		},
		':disabled:hover': {
			backgroundColor: 'transparent',
		},
	},
	toggleButtonActive: {
		backgroundColor: white,
		color: titles,
		boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
		':hover': {
			backgroundColor: white,
		},
	},
	badge: {
		paddingTop: 4,
		paddingBottom: 4,
		paddingLeft: 12,
		paddingRight: 12,
		fontSize: 12,
		fontWeight: 500,
		backgroundColor: shuffleGray,
		color: darkGrayFontColor,
		borderRadius: 12,
	},
	canvasWrapper: {
		flex: 1,
		minHeight: 0,
		display: 'flex',
	},
	canvasContainer: {
		width: '100%',
		height: '100%',
		position: 'relative',
	},
	drawerContent: {
		padding: 16,
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		height: '100%',
		overflowY: 'auto',
	},
	section: {
		backgroundColor: white,
		borderRadius: 8,
		padding: 16,
		boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
	},
	sectionHeader: {
		fontSize: 14,
		fontWeight: 600,
		marginBottom: 12,
		color: titles,
	},
	searchDescription: {
		fontSize: 12,
		color: darkGrayFontColor,
		marginBottom: 12,
		lineHeight: 1.5,
	},
	searchInputRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		marginBottom: 12,
	},
	searchClearButton: {
		border: 'none',
		backgroundColor: backgroundAlt,
		paddingTop: 6,
		paddingBottom: 6,
		paddingLeft: 10,
		paddingRight: 10,
		borderRadius: 4,
		cursor: 'pointer',
		fontSize: 12,
		color: titles,
		':hover': {
			backgroundColor: shuffleGray,
		},
	},
	searchHint: {
		fontSize: 12,
		color: charmGray,
		backgroundColor: background,
		border: `1px dashed ${borderOutline}`,
		borderRadius: 6,
		padding: 10,
	},
	searchResults: {
		listStyle: 'none',
		margin: 0,
		padding: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
	searchResultRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		paddingTop: 10,
		paddingBottom: 10,
		paddingLeft: 12,
		paddingRight: 12,
		border: `1px solid ${shuffleGray}`,
		borderRadius: 6,
	},
	searchResultInfo: {
		flex: 1,
		marginRight: 12,
	},
	addContactButton: {
		border: 'none',
		backgroundColor: brandPrimary,
		color: white,
		paddingTop: 6,
		paddingBottom: 6,
		paddingLeft: 12,
		paddingRight: 12,
		borderRadius: 4,
		fontSize: 12,
		cursor: 'pointer',
		':disabled': {
			opacity: 0.5,
			cursor: 'not-allowed',
		},
		':hover': {
			backgroundColor: brandPrimaryActive,
		},
	},
	contactCard: {
		padding: 12,
		border: `1px solid ${borderOutline}`,
		borderRadius: 6,
		marginBottom: 8,
		cursor: 'pointer',
		transition: 'all 0.2s',
		':hover': {
			backgroundColor: background,
			borderColor: aceGray,
		},
	},
	contactCardSelected: {
		borderWidth: 2,
		backgroundColor: brandPrimaryHoverTint,
	},
	contactCardHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		marginBottom: 8,
	},
	contactColorIndicator: {
		width: 4,
		height: '100%',
		position: 'absolute',
		left: 0,
		top: 0,
		bottom: 0,
		borderTopLeftRadius: 6,
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
		borderBottomLeftRadius: 6,
	},
	contactName: {
		fontSize: 14,
		fontWeight: 600,
		color: titles,
	},
	contactEmail: {
		fontSize: 12,
		color: darkGrayFontColor,
		marginBottom: 4,
	},
	contactPhone: {
		fontSize: 12,
		color: darkGrayFontColor,
		marginBottom: 8,
	},
	contactTags: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 4,
		marginTop: 8,
	},
	contactTag: {
		fontSize: 11,
		paddingTop: 2,
		paddingBottom: 2,
		paddingLeft: 8,
		paddingRight: 8,
		borderRadius: 12,
		backgroundColor: shuffleGray,
		color: charmGray,
	},
	contactKeyFacts: {
		marginTop: 8,
		fontSize: 12,
		color: darkGrayFontColor,
	},
	contactKeyFact: {
		marginBottom: 4,
	},
	progressIndicator: {
		marginTop: 12,
		padding: 12,
		backgroundColor: background,
		borderRadius: 4,
	},
	progressStep: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		marginBottom: 8,
		fontSize: 12,
	},
	progressStepStatus: {
		paddingTop: 2,
		paddingBottom: 2,
		paddingLeft: 6,
		paddingRight: 6,
		borderRadius: 4,
		fontSize: 10,
		fontWeight: 600,
		textTransform: 'uppercase',
	},
	progressStepName: {
		flex: 1,
		fontSize: 11,
	},
	progressStepDueDate: {
		fontSize: 10,
		color: charmGray,
	},
	statusQueued: {
		backgroundColor: warningLight,
		color: warningDark,
	},
	statusSent: {
		backgroundColor: brandPrimaryHoverTint,
		color: brandSecondaryText,
	},
	statusOpened: {
		backgroundColor: successTint,
		color: green3,
	},
	statusFailed: {
		backgroundColor: errorLight,
		color: error,
	},
	legend: {
		position: 'absolute',
		top: 16,
		right: 16,
		backgroundColor: white,
		padding: 12,
		borderRadius: 8,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
		zIndex: 10,
		maxWidth: 200,
	},
	legendTitle: {
		fontSize: 12,
		fontWeight: 600,
		marginBottom: 8,
		color: titles,
	},
	legendItem: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		marginBottom: 6,
		fontSize: 12,
	},
	legendColor: {
		width: 12,
		height: 12,
		borderRadius: '50%',
	},

	legendStepCount: {
		color: charmGray,
		fontSize: 11,
	},
	emptyState: {
		textAlign: 'center',
		padding: 32,
		color: charmGray,
		fontSize: 14,
	},
	searchInput: {
		width: '100%',
		paddingTop: 8,
		paddingBottom: 8,
		paddingLeft: 12,
		paddingRight: 12,
		border: `1px solid ${borderOutline}`,
		borderRadius: 6,
		fontSize: 14,
		marginBottom: 12,
		':focus': {
			outline: 'none',
			borderColor: brandPrimary,
		},
	},
	contactLimit: {
		fontSize: 12,
		color: charmGray,
		marginTop: 8,
		textAlign: 'center',
	},

	searchMaxReachedError: {
		fontSize: 12,
		color: destructive,
		marginTop: 8,
	},

	searchLoadingText: {
		fontSize: 12,
		color: charmGray,
		marginTop: 8,
		textAlign: 'center',
	},

	searchErrorText: {
		fontSize: 12,
		color: destructive,
		marginTop: 8,
		textAlign: 'center',
	},

	searchResultsContainer: {
		marginTop: 12,
		border: `1px solid ${borderOutline}`,
		borderRadius: 6,
		maxHeight: 200,
		overflow: 'auto',
	},

	searchResultItem: {
		paddingTop: 8,
		paddingBottom: 8,
		paddingLeft: 12,
		paddingRight: 12,
		borderBottom: `1px solid ${antiFlashWhite}`,
		cursor: 'pointer',
		backgroundColor: white,
		':hover': {
			backgroundColor: background,
		},
	},

	searchResultItemDisabled: {
		cursor: 'not-allowed',
		backgroundColor: lightGray,
		opacity: 0.5,
		':hover': {
			backgroundColor: lightGray,
		},
	},

	searchResultName: {
		fontSize: 14,
		fontWeight: 600,
	},

	searchResultEmail: {
		fontSize: 12,
		color: darkGrayFontColor,
	},

	searchResultSelected: {
		fontSize: 11,
		color: charmGray,
	},

	searchNoResults: {
		fontSize: 12,
		color: charmGray,
		marginTop: 8,
		textAlign: 'center',
	},

	eligibleContactCard: {
		padding: 8,
		border: `1px solid ${borderOutline}`,
		borderRadius: 6,
		marginBottom: 8,
		cursor: 'pointer',
		':hover': {
			backgroundColor: background,
		},
	},

	eligibleContactCardDisabled: {
		cursor: 'not-allowed',
		opacity: 0.5,
		':hover': {
			backgroundColor: 'transparent',
		},
	},

	eligibleContactName: {
		fontSize: 14,
		fontWeight: 600,
	},

	eligibleContactEmail: {
		fontSize: 12,
		color: darkGrayFontColor,
	},

	clearAllButton: {
		fontSize: 12,
		paddingTop: 4,
		paddingBottom: 4,
		paddingLeft: 8,
		paddingRight: 8,
		backgroundColor: 'transparent',
		color: destructive,
		border: `1px solid ${destructive}`,
		borderRadius: 4,
		cursor: 'pointer',
		':hover': {
			backgroundColor: errorLight,
		},
	},

	selectedContactsHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: 12,
	},

	sectionHeaderNoMargin: {
		marginBottom: 0,
	},

	// New styles for converted inline styles
	centeredContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
	},

	loadingText: {
		fontSize: 16,
		color: darkGrayFontColor,
	},

	errorText: {
		fontSize: 16,
		color: destructive,
	},

	mainContentContainer: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		display: 'flex',
		flexDirection: 'column',
	},
});
